import React from "react";
import { MdStar } from "react-icons/md";
import styles from "./ProductRatingSection.module.scss";
import { useTheme } from "../hooks/useTheme";
import { RatingDisplay } from "./RatingDisplay";
import { useSelector } from "react-redux";
import { selectCurrentCluster } from "../../store/slices/currentClusterSlice";

interface ProductRatingSectionProps {
  item: any;
  canRate: boolean;
  hasUserRating: boolean;
  onRatePress: () => void;
  backgroundColor?: string;
  textColor?: string;
  title?: string;
  showTitle?: boolean;
}

export const ProductRatingSection: React.FC<ProductRatingSectionProps> = ({
  item,
  canRate,
  hasUserRating,
  onRatePress,
  backgroundColor,
  textColor,
  title = "Рейтинг",
  showTitle = true,
}) => {
  const { theme } = useTheme();
  const currentCluster = useSelector(selectCurrentCluster);

  // ❌ Если showRating = false — ничего не рендерим
  if (!currentCluster?.showRating) {
    return null;
  }

  const finalBackgroundColor = backgroundColor ?? theme.card;
  const finalTextColor = textColor ?? theme.text;

  return (
    <section
      className={styles.ratingSection}
      style={{ backgroundColor: finalBackgroundColor }}
    >
      {showTitle && (
        <div className={styles.ratingHeader}>
          <h3 className={styles.ratingTitle} style={{ color: finalTextColor }}>
            {title}
          </h3>

          {canRate && !hasUserRating && (
            <button className={styles.rateButton} onClick={onRatePress}>
              <MdStar size={20} color={theme.onPrimary} />
              <span className={styles.rateButtonText}>Оценить</span>
            </button>
          )}
        </div>
      )}

      <RatingDisplay item={item} />
    </section>
  );
};
